// Employee Positions Management Permissions

export const EMPLOYEES_POSITIONS_INDEX = 61;
export const EMPLOYEES_POSITIONS_CREATE = 62;
export const EMPLOYEES_POSITIONS_EDIT = 63;
export const EMPLOYEES_POSITIONS_DELETE = 64;
export const EMPLOYEES_POSITIONS_RESTORE = 1381;
